import { cn } from "@/components/podkit/lib/cn";
import {
    currentStepAtom,
    ONBOARDING_STEP,
    ONBOARDING_STEP_SLUG,
    type OnboardingStep,
} from "@/routes/ona-onboarding/onboarding-state";
import { useAtomValue, useSetAtom } from "jotai";
import { type PropsWithChildren } from "react";
import { Link } from "react-router-dom";

export function OnboardingStepIndicator({ className }: PropsWithChildren<{ className?: string }>) {
    return (
        <div className={cn("flex flex-row items-center justify-center space-x-2 font-mono", className)}>
            <StepIndicator step={ONBOARDING_STEP[ONBOARDING_STEP_SLUG.connectToScm]} />
            <StepIndicatorSeparator />
            <StepIndicator step={ONBOARDING_STEP[ONBOARDING_STEP_SLUG.selectRepository]} />
            <StepIndicatorSeparator />
            <StepIndicator step={ONBOARDING_STEP[ONBOARDING_STEP_SLUG.getStartedWithTasks]} />
        </div>
    );
}

function StepIndicatorSeparator() {
    return <hr className="h-1 w-4 border-t border-dashed border-t-border-subtle" />;
}

function StepIndicator({ step }: { step: OnboardingStep }) {
    const setCurrentStep = useSetAtom(currentStepAtom);
    const currentStep = useAtomValue(currentStepAtom);

    const isActive = currentStep.index === step.index;
    const isCompleted = currentStep.index > step.index;
    const isFuture = currentStep.index < step.index;
    const className = cn(
        "flex h-8 w-8 items-center justify-center rounded-full border border-border-subtle select-none",
        {
            "text-content-brand": isActive,
            "text-content-tertiary/40": isFuture,
        },
    );

    if (isCompleted) {
        return (
            <Link
                replace
                to={`/onboarding/ona/${step.slug}`}
                className={cn(className, "hover:bg-surface-hover")}
                onClick={() => {
                    setCurrentStep(step);
                }}
                data-tracking-id={`navigate-step-${step.slug}-onboarding-step-indicator`}
            >
                {step.index}
            </Link>
        );
    }

    return <div className={className}>{step.index}</div>;
}
